<div class="alinhamento">
    <img src="../../../../assets/image/logoCabecaNuvem_branco.png" alt="logo" class="logo">
</div>
